import React from "react";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Form,
  Card,
  Col
} from "antd";

// PROJECT IMPORTS
import appLabel from "../../../../../config/appLabel";

const { Text } = Typography;

export default function CurrencyForm({ redeDetail }) {
  const [useForm] = Form.useForm();

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.currency}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.currency?.name}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.decimalPlaces}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.currency?.decimalPlaces}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.multiplesOf}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.currency?.inMultiplesOf}
              ></Input>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
}
